import { render, staticRenderFns } from "./MessageListItem.vue?vue&type=template&id=3ac834aa&scoped=true&"
import script from "./MessageListItem.vue?vue&type=script&lang=js&"
export * from "./MessageListItem.vue?vue&type=script&lang=js&"
import style0 from "./MessageListItem.vue?vue&type=style&index=0&id=3ac834aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac834aa",
  null
  
)

export default component.exports